import { attachmentFieldKey } from '@components/utils/inputElements/FileInput';
import { FORM_OPT_IN_KEY } from '@constants';
import { FormFieldOrConsent } from '@types';

export const getFieldKey = (field: FormFieldOrConsent, index: number) => {
    switch (field.__typename) {
        case 'ComponentFormFieldsInput':
        case 'ComponentFormFieldsDateInput':
        case 'ComponentFormFieldsSingleSelect':
            return field.Name;

        case 'ComponentFormFieldsFileInput':
            return attachmentFieldKey(field.Name);

        case 'ComponentConsentsEmail':
            return FORM_OPT_IN_KEY;

        default:
            return `field-${index}`;
    }
};
